export const formSchema = {
  title: 'Database schema',
  type: 'object',
  additionalProperties: false,
  properties: {
    alias: {
      type: 'string',
      title: 'Alias',
    },
    version: {
      type: 'number',
      title: 'Version',
    },
    countryCode: {
      type: 'string',
      enum: ['US', 'CA', 'BO'],
      title: 'Country code',
    },
    collections: {
      type: 'array',
      title: 'Collections',
      items: {
        title: 'Collection',
        type: 'object',
        properties: {
          collection: {
            type: 'string',
            title: 'Firestore collection name',
          },
          sqliteTable: {
            type: 'string',
            title: 'SQLite table name',
          },
          type: {
            title: 'Firestore database type',
            enum: ['geofirestore', 'db'],
            type: 'string',
          },
          filter: {
            type: 'object',
            title: 'Filter (when)',
            properties: {
              attribute: {
                type:"string",
                title: "Collection field"
              },
              value: {
                type:"string",
                title: "Value"
              }
            }
          },
          attributes: {
            type: "array",
            title: "Attributes",
            items: {
              type: "object",
              properties: {
                name: {
                  type: "object",
                  title: "Name",
                  properties: {
                    firebase: {
                      type: "string",
                      title: "firebase name"
                    },
                    sqlite: {
                      title: "sqlite name",
                      oneOf: [
                        {
                          type: "string",
                          title: "SQLite column name"
                        },
                        {
                          type: "array",
                          title: "SQLite column names (for latitude & longitude)",
                          maxItems: 2,
                          items: {
                            type: "string",
                            title: "Column name"
                          }
                        }
                      ]
                    }
                  },
                  required: ['firebase', 'sqlite'],
                },
                type: {
                  type: "object",
                  title: "Type",
                  properties: {
                    firebase: {
                      type: "string",
                      title: "Firestore field type",
                      enum: ['boolean', 'string', 'geopoint', 'array']
                    },
                    sqlite: {
                      type: "string",
                      title: "SQLite data type",
                      enum: ['integer', 'text', 'real']
                    }
                  },
                  required: ['firebase', 'sqlite'],
                }
              },
              required: ['name', 'type'],
            }
          },
        },
        required: ['collection', 'sqliteTable', 'type', 'attributes'],
      },
    },
  },
  required: ['alias', 'version', 'countryCode', 'collections'],
};
